import { Dispatch, SetStateAction } from 'react';

import { Icon, IconButton, Switch } from '@atom/mui';
import { AssetRequestCreateInput } from '@atom/types/assetRequest';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { View } from '../CreateRequestModal';

import classes from './ardotCreate.module.css';

const styles = {
  switch: {
    margin: '0',
  },
};

interface Props {
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  setView: Dispatch<SetStateAction<View>>;
  transferToggle: boolean;
  setTransferToggle: Dispatch<SetStateAction<boolean>>;
}

const TransferSection = ({
  createInputs,
  updateCreateInput,
  setView,
  transferToggle,
  setTransferToggle,
}: Props) => {
  const toggleTransfer = () => {
    updateCreateInput(null, 'reviewer');
    updateCreateInput(null, 'receiver');

    if (toggleTransfer) {
      updateCreateInput(null, 'toCategoryId');
      updateCreateInput(null, 'toCategoryPath');
    }

    setTransferToggle(!transferToggle);
  };

  return (
    <>
      <div>
        <div className={classes.transferTitle}>Transfer</div>
        <div className={classes.transferTitleSub}>
          <div>
            Transfer the inventory to another district or division once the
            request is approved.
          </div>
          <Switch
            sx={styles.switch}
            checked={transferToggle}
            onChange={toggleTransfer}
          />
        </div>
      </div>
      {transferToggle && (
        <>
          <div className={classes.viewRow}>
            <div className={classes.rowTitle}>From District or Division</div>
            <div>{createInputs.categoryPath}</div>
          </div>
          <div className={classes.viewRow}>
            <div className={classes.rowTitle}>To District or Division</div>
            {isNilOrEmpty(createInputs.toCategoryId) ? (
              <div
                className={classes.selectButton}
                onClick={() => setView(View.CATEGORY)}
              >
                SELECT
              </div>
            ) : (
              <div className={classes.categoryTile}>
                <div>{createInputs.toCategoryPath}</div>
                <IconButton size="small" onClick={() => setView(View.CATEGORY)}>
                  <Icon>edit</Icon>
                </IconButton>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TransferSection;
